import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import user from './reducers/user';
import banner from './reducers/banner';
import tag from './reducers/tag';
import outlet from './reducers/outlet';
import order from './reducers/order';
import category from './reducers/category';
import favorite from './reducers/favorite';
import search from './reducers/search';
import cart from './reducers/cart';
import product from './reducers/product';
import voucher from './reducers/voucher';
import location from "./reducers/location";
import payment from "./reducers/payment";
import color from "./reducers/color";
import history from './reducers/history';
import device from './reducers/device';
import layout from './reducers/layout';
import company from './reducers/ufood-x/company';
import menu from './reducers/ufood-x/menu';
import loyalty from './reducers/loyalty';
import gps from './reducers/gps';
import card from './reducers/card';
import article from './reducers/ufood-x/article';
import { injectStore } from '../utils/helper';

const persistConfig = {
  key: "ufood-widget",
  storage,
};

const rootReducer = combineReducers({
  location,
  user,
  outlet,
  banner,
  tag,
  order,
  category,
  favorite,
  search,
  cart,
  product,
  voucher,
  payment,
  color,
  history,
  device,
  layout,
  company,
  menu,
  loyalty,
  gps,
  article,
  card,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REGISTER",
          "persist/REHYDRATE",
        ],
      },
    }),
});

const persistor = persistStore(store);

// persistor.purge();
injectStore(store);

export { store, persistor };
